export default "__VITE_ASSET__BIrDYTPV__"